const borderStyle = {
  borderColor: '#000000',
  borderStyle: 'thin'
}

export const tableHeaderStyle = {
  ...borderStyle,
  align: 'center',
  alignVertical: 'center',
  backgroundColor: '#9CDCEA',
  fontWeight: 'bold',
  wrap: true
}

export function buildSimpleExportSheet({
  header = [],
  data = [],
  sheetName = 'Sheet1',
  headerStyle
}) {
  const keys = data[0] ? Object.keys(data[0]) : []
  const sheetData = [
    header.map((value) => ({
      value,
      ...(headerStyle || {})
    })),
    ...data.map((row) =>
      keys.map((key) => ({
        value: row[key] ?? ''
      }))
    )
  ]

  return {
    sheetData,
    sheetOptions: {
      sheet: sheetName
    }
  }
}
